module.exports = __webpack_public_path__ + "img/product-category-engagementrings@2x.2844699.webp";